import Generator from '@/models/Generator'
import User, { hasRole, Role } from '@/models/User'

export default class GeneratorPolicy {
	viewAny(_user: User): boolean {
		return true
	}

	view(user: User, generator: Generator) {
		switch (user.role) {
			case Role.USER:
				return user.company?.id === generator.entry.catalog.company.id
			case Role.AUDITOR:
				return generator.entry.catalog.company.auditors?.some(auditor => auditor.id === user.auditor?.id)
			default:
				return false
		}
	}

	create(user: User) {
		return hasRole(user, Role.USER)
	}

	update(user: User, generator: Generator) {
		return hasRole(user, Role.USER) && user.company?.id === generator.entry.catalog.company.id
	}

	restore(user: User, generator: Generator) {
		return hasRole(user, Role.USER) && user.company?.id === generator.entry.catalog.company.id
	}

	delete(user: User, generator: Generator) {
		return hasRole(user, Role.USER) && user.company?.id === generator.entry.catalog.company.id
	}

	forceDelete(_user: User, _generator: Generator) {
		return false
	}
}
